import React, {Fragment} from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';
import    InvoiceTableHeader from './InvoiceTableHeader'
import InvoiceTitle from './InvoiceTitle'


const InvoiceTableRow =  ({items, invoice}) =>  {
    var counter=0
    const rows =items.map( (item,index) => 
        
        {
        counter++

        return (
            <View>
        {/* { counter%9==0
        ?
             <View style={ {
                flexDirection: 'row',
                alignItems: 'center',
                width:"100%",
                height: item.reporting_date.includes("2022") ? "140em" : "80em"
                }} key={item.test_title} >
                    </View>
                    :null
        } */}
        {/* {
            counter%9==0 ?
            <>
            <InvoiceTableHeader  />
            </>
            : null
        } */}
        <View style={ {
        flexDirection: 'row',
        borderBottomColor: 'BLACK',
        borderBottomWidth: 0.5,
        // borderTopWidth: counter%9 ? 0.5 :0,
        alignItems: 'center',
        width:"100%",
        fontSize:7,
        fontStyle: 'bold'
       
        }} key={item.test_title} >
             <Text style={{ 

        width: '10%',
        textAlign: 'left',
        borderLeftColor: 'black',
        borderLeftWidth: 0.5,
        height:'100%',
        padding:5,  
        fontSize:7,
        }}>{(index+1)}</Text>
         {/* <Text style={{ 
                 
        width: '40%',
        fontFamily: 'Helvetica-Bold',
        textAlign: 'left',
        borderLeftColor: 'black',
        borderLeftWidth: 0.5,
        fontSize:6,
        height:'100%',
        padding:5
        
        
        }}>{item.test_title}</Text> */}
          {/* // this is for row adding by sir najam waiting for sir kamran 10-jan-2023 and change in LabTest  1096 and 2077 */}
          <View style={{

width: '65%',
// fontFamily: 'Helvetica-Bold',
// textAlign: 'left',
borderLeftColor: 'black',
borderLeftWidth: 0.5,
// fontSize: 6,
height: '100%',
padding: 5


}}>
                <Text style={{

                    // width: '100%',
                    fontFamily: 'Helvetica-Bold',
                    textAlign: 'left',
                    // borderLeftColor: 'black',
                    // borderLeftWidth: 0.5,
                    fontSize: 6,
                    // height: '100%',
                    // padding: 5


                }}>{item.test_title}</Text>
                  <Text style={{

// width: '25%',
// fontFamily: 'Helvetica-Bold',
textAlign: 'left',
// borderLeftColor: 'black',
// borderLeftWidth: 0.5,
fontSize: 6,
// height: '100%',
// padding: 5


}}>{item.tests_line_details}</Text>
</View>
         {/* <Text style={{ 
                 
        width: '25%',
        height:'100%',
        textAlign: 'center',
        borderLeftColor: 'black',
        borderLeftWidth: 0.5,
        fontSize:6.5,
        borderRightWidth: 0.5,
        textOverflow: 'auto',
        padding: 5
        
        
        }}>{item.reporting_date}</Text> */}
         {/* //  25-apr-2024 to show reporting time in invoice for call a group in lab-test aalso agg group:true */}

{item.group ?
         <Text style={{ 
                 
            width: '25%',
            height:'100%',
            textAlign: 'center',
            borderLeftColor: 'black',
            borderLeftWidth: 0.5,
            fontSize:6.5,
            borderRightWidth: 0.5,
            textOverflow: 'auto',
            padding: 5
        
        
        }}>
           {'\n'}{'\n'}
            {

        item.reporting_date}</Text>:
        <Text style={{ 
                 
            width: '25%',
            height:'100%',
            textAlign: 'center',
            borderLeftColor: 'black',
            borderLeftWidth: 0.5,
            fontSize:6.5,
            borderRightWidth: 0.5,
            textOverflow: 'auto',
            padding: 5
            
            
            }}>
              
                {
    
            item.reporting_date}</Text>
    }
         
     
     </View>
     </View>
    )
        })
    

        return (<View>{rows}</View>)
    
};
  
  export default InvoiceTableRow